import styled from '@emotion/styled'

const HeroContainer = styled.section`
    position: relative;
    background-color: #242f3f;

    display: flex;
    flex-direction: column;
    justify-content: center;
`

const HeroHeadingSubSection = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    h3 {
        color: white; 
        letter-spacing: 0;
    }

    @media (max-width: ${props => props.theme.bps.lg}) {
        padding: 0;

        align-items: center;

        h1 {
            min-height: inherit;
        }

        p {
            max-width: 20rem;
            color: grey;
        }
    }
`

const TextContent = styled.div`
    min-width: 20rem;

    h2,
    h3 {
        margin-bottom: 4rem;
    }
    p + p {
        margin-top: 2rem;
    }

    @media (min-width: ${props => props.theme.bps.lg}) {
        margin-top: 5rem;
    }
`

const TextContentCentered = styled(TextContent)`
    max-width: 50rem;
    justify-content: center;
    text-align: center;
`

const Section = styled.div<{ justifyContent?: string }>`
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: ${({ justifyContent = 'space-between' }) => justifyContent};
    gap: 2.5rem;
    @media (min-width: ${props => props.theme.bps.md}) {
        gap: 3.5rem;
        // border: 2px solid yellow;
    }
    // @media (min-width: ${props => props.theme.bps.xl}) {
    //     border: 2px solid aqua;
    // }
`

const ExchangeWidgetSubSection = styled.div`
    margin: 0 2rem 0 auto;

    @media (max-width: ${props => props.theme.bps.lg}) {
        margin: auto;
    }
`

const OnRampingTextSubSection = styled.div`
    margin: 0 auto 0;
    width: auto;
`

export {
    HeroContainer,
    HeroHeadingSubSection,
    OnRampingTextSubSection,
    ExchangeWidgetSubSection,
    Section,
    TextContentCentered,
    TextContent,
}
